'use client';

export default function FooterAccessibility({ locale }: { locale: string }) {
    if (!['us', 'ca'].includes(locale)) {
        return null;
    }
    return (
        <>
            {locale === 'us' && <div className="divider"></div>}
            <div className="accessibility-settings">
                <a id="accessibility-settings" className="accessibility-settings">
                    Accessibility
                </a>
            </div>
        </>
    );
}
